module.exports = __webpack_public_path__ + "static/media/1f913.31151024.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f913.svg
// module id = 615
// module chunks = 1